import React from 'react';
import PropTypes from 'prop-types';
import './articleHead.css';
import { AddThis } from '../addThis';
import cx from 'classnames';

class ArticleHead extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      share: false,
    };
  }

  render() {
    return (
      <div className="article-head">
        <div
          className="article-head-content"
          style={{ backgroundImage: "url('" + this.props.image + "')" }}
        >
          {this.props.head}
          {React.cloneElement(this.props.title, {
            onClickShare: () => {
              this.setState({ share: true });
            },
          })}
        </div>
        <div
          className={cx('article-head-share', { active: this.state.share })}
          onClick={ev => ev.preventDefault()}
        >
          <span
            className="close-btn"
            onClick={ev => this.setState({ share: false })}
          >
            &times;
          </span>
          <AddThis
            shareUrl={this.props.shareUrl}
            shareTitle={this.props.shareTitle}
            sharePicture={this.props.sharePicture}
          />
        </div>
        {this.props.children}
      </div>
    );
  }
}

ArticleHead.propTypes = {
  image: PropTypes.string,
  title: PropTypes.element,
  head: PropTypes.element,
  shareUrl: PropTypes.string,
  shareTitle: PropTypes.string,
  sharePicture: PropTypes.string,
  children: PropTypes.node,
};

export default ArticleHead;



// WEBPACK FOOTER //
// ./src/ui/src/component/article/articleHead.js